import { get } from 'jquery';
import {apiUrl} from '../constant';
import {authtoken} from 'global.js';
const axios = require("axios");
export const taskmanageService = {
    gettasks,
    getstatus,
    getclientstatus,
    getclienttransitionstatus,
    getrejectionstatus,
    getcompanieslistsname,
    editRow,
    moveAutomationToNew,
    editTask,
    getDashboardData,
    getClientDashboardData,
    getphaselistsselection,
    addphase,
    rejectionphase,
    rejectionclient,
    get_qa_analystteamleaderlist,
    getanalystteamleaderlist,
    getnotification,
    read_all,
    clearall_notification,
    clearsingle_notify,
    addcomment,
    addcommentClient,
    getcommentlists,
    getClientcommentlists,
    archivetask,
    updateurgencyFlag,
    approveBilling,
    getfilterlist,
    getarchivetasks,
    restoreTask,
    gettaskdetail,
    download_report,
    download_turnaround_report,
    getclientTasks,
    get_files_folders,
    skipphase,
    geterrorcategories,
    editRejectionRow,
    editexternalRejectionRow,
    download_all_file,
    download_file,
    getrejectionphaselists,
    getsubclientTasks,
    getgovernancestatus,
    getBillingDashboardData,
    getBillingDashboardStatistics,
    editBillingRow,
    client_task_report,
    transitionForm,
    backphase,
    clientdetailsexportmail,
  saveClientMisBody,
    save_budget,
    get_budget_client,
    save_announcement,
    getAnnouncement,
    getsingleAnnouncement,
    update_announcement,
    deleteAnnouncement,
    getactiveAnnouncement,
    getclienttransByTask,
    phasedelete,
    getchecklistData,
    editChecklistForm,
    addChecklistData,
    get_single_manager_rejection,
    getKYCDashboard,
    download_KYCDashreport,
    download_clientList,
    getPhases,
    getPriceRevisionDashboard,
    anniversarymailsend,
    editCommonTable,
    getchecklistSubCatData,
    getPhaseClientdetail,
    anniversarydashboardCountData,
    download_anniversary_report,
    getMisMailDetails,
    getMisMailWeeklyData,
    getpodData,
    reorderTasks,
    kanbanviewdata,
    ageingreport,
    ageingdetails,
    deleteBillingBreakup,
    editChecklistUpdate,
    updateFeedbackTracking,
    getFeedbackOptions,
    saveFeedbackOption,
    updateDashboardChecklistData,
    removeChecklistRow,
    reworkphase,
    getReworkData,
    editReworkField,
    reassignphase,
    getReassignData,
    editReassignField,
    getOnHoldHistory,
    getJobHistory,
    archiveChecklistFeedback,
    getChecklistFeedbackData,
    getQAChecklistFeedbackData,
    deleteRej,
    addInternalPhaseError,
    add_timesheet,
    get_timesheet_data,
    getTasksList,
    getdocumentdetail,
    s3Browse,
    s3BucketBrowse,
    getDocumentsView,
    download_all_fileS3,
    reprocessDocument,
    updateUploadDocType,
    getOnHoldPhases
};

function updateUploadDocType(payload) {
  return axios({
    method: "POST",
    url: `${apiUrl}/upload-doc/update-type`,
    data: payload,
    headers: {
      Authorization: `Bearer ${authtoken}`,
      "Content-Type": "application/json",
    },
  })
    .then((response) => response)
    .catch((error) => {
      console.error("Update upload doc type error:", error?.response?.status, error?.response?.data || error.message);
      throw error;
    });
}

function geterrorcategories(){
  return axios({
    method: "get",
    url: `${apiUrl}/getcategories`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
    });
}

function editRejectionRow(value,field,id){
  var bodyFormData = new FormData();
  bodyFormData.append("id", id);
  bodyFormData.append("field", field);
  bodyFormData.append("value", value);
  return axios({
      method: "POST",
      url: `${apiUrl}/task-rejection-edit`,
      data: bodyFormData,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
        return response;
      }, error => {
       // return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}

function reorderTasks(reorderedIds){
  return axios({
    method: "POST",
    url: `${apiUrl}/reorderTasks`,
    data: { ids: reorderedIds },  // Sending the array as JSON
    headers: {
      Authorization: `Bearer ${authtoken}`,
      'Content-Type': 'application/json',  // Ensure proper content type
    },
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.response) {
        console.log("Error status:", error.response.status);
      } else {
        console.log("Error:", error.message);
      }
    });

}

function editexternalRejectionRow(value,field,id){
  var bodyFormData = new FormData();
  bodyFormData.append("id", id);
  bodyFormData.append("field", field);
  bodyFormData.append("value", value);
  return axios({
      method: "POST",
      url: `${apiUrl}/task-rejection-external`,
      data: bodyFormData,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
        return response;
      }, error => {
       // return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}

function editBillingRow(value,field,id,table){
  var bodyFormData = new FormData();
  bodyFormData.append("id", id);
  bodyFormData.append("field", field);
  bodyFormData.append("value", value);
  bodyFormData.append("table", table);
  return axios({
      method: "POST",
      url: `${apiUrl}/billing-update`,
      data: bodyFormData,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
        return response;
      }, error => {
       // return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}


function gettasks(page,search,filter,filtertype,sortfield,sortorder,start_date,end_date,per_page,phase,yearEnd_startDate='',YearEnd_end_date=''){
  let filters = '';
  if(filter){
     filters = `&filters=${JSON.stringify(filter)}`;
  }
  let typefilter = '';
  if(filtertype!=''){
     typefilter = `&filtertype=${filtertype}`;
  }
    return axios({
        method: "get",
        url: `${apiUrl}/dashboard?page=${page}&search=${encodeURIComponent(search)}${filters}${typefilter}&sort=${sortfield}&order=${sortorder}&start_date=${start_date}&end_date=${end_date}&per_page=${per_page}&phase=${phase}&yearEnd_startDate=${yearEnd_startDate}&YearEnd_end_date=${YearEnd_end_date}`,
        headers: {Authorization: `Bearer ${authtoken}` },
      })
        .then(function (response) {
           if(response.status == 200){
                return response;  
           }
        }, error => {
          return error.response;
          console.log(error.response.status);
        })
        .catch(function (error) {
          // console.log(error.response.status);
        });      
}

function saveClientMisBody(user_id, body){
  var bodyFormData = new FormData();
  bodyFormData.append('user_id', user_id);
  bodyFormData.append('body', body);
  return axios({
      method: 'POST',
      url: `${apiUrl}/save-client-mis-body`,
      data: bodyFormData,
      headers: { Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
    });
}

function getstatus(type=''){
  return axios({
    method: "get",
    url: `${apiUrl}/statuslist?type=`+type,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function getcompanieslistsname(search){
  return axios({
      method: "get",
      url: `${apiUrl}/task-list?search=${search}`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
         if(response.status == 200){
              return response;
         }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}

function getphaselistsselection(task_id){
  return axios({
      method: "get",
      url: `${apiUrl}/phase-list-selection?task_id=`+task_id,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
         if(response.status == 200){
              return response;
         }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}

function getrejectionphaselists(task_id){
  return axios({
      method: "get",
      url: `${apiUrl}/rejection-phase-list?task_id=`+task_id,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
         if(response.status == 200){
              return response;
         }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}

function gettaskdetail(task_id,id,type){
  if(id!=''){
    var ss = `&id=${id}&type=${type}`;
  }else{
    var ss = '';
  }
  return axios({
    method: "get",
    url: `${apiUrl}/task-detail?task_id=${task_id}${ss}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;
       }
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });    
}
function editRow(value,field,id,type,no_error_data=''){
  var bodyFormData = new FormData();
  bodyFormData.append("type", type);
  bodyFormData.append("id", id);
  bodyFormData.append("field", field);
  bodyFormData.append("value", value);
  // bodyFormData.append("no_error_data", no_error_data);
  return axios({
      method: "POST",
      url: `${apiUrl}/task-edit`,
      data: bodyFormData,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
        return response;
      }, error => {
       // return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}

function moveAutomationToNew(task_id){
  var bodyFormData = new FormData();
  bodyFormData.append("task_id", task_id);
  return axios({
      method: "POST",
      url: `${apiUrl}/task-move-automation-new`,
      data: bodyFormData,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
        return response;
      }, error => {
        return error.response;
      });
}

function editTask(value,id,type){
  var bodyFormData = new FormData();
  bodyFormData.append("type", type);
  bodyFormData.append("id", id);
  bodyFormData.append("value", value);
  return axios({
      method: "POST",
      url: `${apiUrl}/task-approve-reject`,
      data: bodyFormData,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
        return response;
      }, error => {
       // return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}

function addphase(analyst,phases_arr){
  let phases = {'phases' : phases_arr};
  let dta = Object.assign(analyst, phases);
  return axios({
      method: "POST",
      url: `${apiUrl}/phase-selection`,
      data:dta,
      headers: { Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      // if(response.status == 200){
        return response;  
      // }
    }, error => {
        return error.response;
      })
    }

    function skipphase(task_id){
      return axios({
          method: "get",
          url: `${apiUrl}/phase-skip?task_id=`+task_id,
          headers: { Authorization: `Bearer ${authtoken}` },
        })
        .then(function (response) {
          // if(response.status == 200){
            return response;  
          // }
        }, error => {
            return error.response;
          })
        }

    function backphase(task_id){
      return axios({
          method: "get",
          url: `${apiUrl}/phase-back?task_id=`+task_id,
          headers: { Authorization: `Bearer ${authtoken}` },
        })
        .then(function (response) {
          // if(response.status == 200){
            return response;  
          // }
        }, error => {
            return error.response;
          })
        }

function rejectionphase(data,phases_arr){
  let phases = {'phases' : phases_arr};
  let dta = Object.assign(data, phases);
  return axios({
      method: "POST",
      url: `${apiUrl}/task-approve-reject`,
      data: dta,
      headers: { Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      // if(response.status == 200){
        return response;  
      // }
    }, error => {
        return error.response;
      })
}

function reworkphase(data,phases_arr){
  let phases = {'reworks' : phases_arr};
  let dta = Object.assign(data, phases);
  return axios({
      method: "POST",
      url: `${apiUrl}/task-rework`,
      data: dta,
      headers: { Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      // if(response.status == 200){
        return response;
      // }
    }, error => {
        return error.response;
      })
}

function reassignphase(data,phases_arr){
  let phases = {'reassigns' : phases_arr};
  let dta = Object.assign(data, phases);
  return axios({
      method: "POST",
      url: `${apiUrl}/task-reassign`,
      data: dta,
      headers: { Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
        return response;
    }, error => {
        return error.response;
      })
}

function rejectionclient(data,phases_arr){
  let phases = {'phases' : phases_arr};
  let dta = Object.assign(data, phases);
  return axios({
      method: "POST",
      url: `${apiUrl}/task-client-reject`,
      data: dta,
      headers: { Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      // if(response.status == 200){
        return response;  
      // }
    }, error => {
        return error.response;
      })
}

function getClientDashboardData(start_date,end_date,client){
  if(start_date!=null && end_date!=null){
    var sendData = 'start_date='+start_date+'&end_date='+end_date+'&client='+client;
  }else{
    var sendData = '';
  }
  return axios({
    method: "get",
    url: `${apiUrl}/client-dashboard?${sendData}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function getDashboardData(){
  return axios({
      method: "get",
      url: `${apiUrl}/statistics`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
         if(response.status == 200){
              return response;
         }
      }, error => {
        return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}

function get_qa_analystteamleaderlist(){
  return axios({
      method: "get",
      url: `${apiUrl}/qaanalyst-tl`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      if(response.status == 200){
        return response;
       }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        console.log(error.response.status);
      });      
}

function getanalystteamleaderlist(){
  return axios({
      method: "get",
      url: `${apiUrl}/analyst-tl`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      if(response.status == 200){
        return response;
       }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        console.log(error.response.status);
      });      
}

function getnotification(){
  return axios({
    method: "get",
    url: `${apiUrl}/getnotification`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
    if(response.status == 200){
      return response;
     }
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });
}

function read_all(){
  return axios({
    method: "post",
    url: `${apiUrl}/notification/readall`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });
}

function clearall_notification(){
  return axios({
    method: "post",
    url: `${apiUrl}/notification/clearall`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    }); 
}

function clearsingle_notify(id){
  var bodyFormData = new FormData();
  bodyFormData.append("id", id);
  return axios({
    method: "post",
    url: `${apiUrl}/notification/clear_single`,
    data:bodyFormData,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    }); 
}

function addcomment(comment_data){
  console.log(comment_data)
  return axios({
      method: "post",
      url: `${apiUrl}/add-comment`,
      data: comment_data,
      headers: { Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      if(response.status == 200){
        return response;
       }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        console.log(error.response.status);
      });      
}

function addcommentClient(comment_data){
  var bodyFormData = new FormData();
  bodyFormData.append("task_id", comment_data.task_id);
  bodyFormData.append("comment", comment_data.comment);
  bodyFormData.append("is_client", 1);
  return axios({
      method: "post",
      url: `${apiUrl}/add-comment`,
      data: bodyFormData,
      headers: { Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      if(response.status == 200){
        return response;
       }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        console.log(error.response.status);
      });      
}

function getcommentlists(task_id,type,id){
  return axios({
      method: "get",
      url: `${apiUrl}/commentlists?task_id=`+task_id+`&id=`+id+`&type=`+type,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      if(response.status == 200){
        return response;
       }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        console.log(error.response.status);
      });      
}

function getClientcommentlists(task_id){
  return axios({
    method: "get",
    url: `${apiUrl}/clientcommentlists?task_id=`+task_id,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
    if(response.status == 200){
      return response;
     }
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });
}

function archivetask(data){
  console.log(data)
  return axios({
    method: "post",
    url: `${apiUrl}/delete-task`,
    data: data,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}

function updateurgencyFlag(data){
  return axios({
    method: "post",
    url: `${apiUrl}/update-task-flag`,
    data: data,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    }); 
}
function approveBilling(data,client='',date='',service=''){
  return axios({
    method: "post",
    url: `${apiUrl}/billing-approve`,
    data: {billing_data: data, client: client, date: date, service: service},
    headers: { Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    }); 
}

function getfilterlist(){
  return axios({
    method: "get",
    url: `${apiUrl}/filter-list`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });
}

function getarchivetasks(page,per_page){

    return axios({
        method: "get",
        url: `${apiUrl}/archive-list?page=${page}&per_page=${per_page}`,
        headers: {Authorization: `Bearer ${authtoken}` },
      })
        .then(function (response) {
           if(response.status == 200){
                return response;  
           }
        }, error => {
          return error.response;
          console.log(error.response.status);
        })
        .catch(function (error) {
          // console.log(error.response.status);
        });      
}

function getclientTasks(page,search,filter,filtertype,sortfield,sortorder,start_date,end_date){
  let filters = '';
  if(filter){
     filters = `&filters=${JSON.stringify(filter)}`;
  }
  let typefilter = '';
  if(filtertype!=''){
     typefilter = `&filtertype=${filtertype}`;
  }
  return axios({
      method: "get",
      url: `${apiUrl}/client-task-list?page=${page}&search=${search}${filters}${typefilter}&sort=${sortfield}&order=${sortorder}&start_date=${start_date}&end_date=${end_date}`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
         if(response.status == 200){
              return response;  
         }
      }, error => {
        return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}
function getsubclientTasks(page,client,subclient){
  return axios({
      method: "get",
      url: `${apiUrl}/subclient-task-list?page=${page}&client=${encodeURIComponent(client)}&subclient=${encodeURIComponent(subclient)}`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
         if(response.status == 200){
              return response;  
         }
      }, error => {
        return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}

function restoreTask(id){
  return axios({
    method: "get",
    url: `${apiUrl}/restore-task?id=${id}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}

function download_report(filter,filtertype,start_date,end_date,data_type=0,search='',yearEnd_startDate='',YearEnd_end_date=''){
  let filters = '';
  // let search = '';
  if(filter){
     filters = `&filters=${JSON.stringify(filter)}`;
  }
  let typefilter = '';
  if(filtertype!=''){
     typefilter = `&filtertype=${filtertype}`;
  }
  return axios({
    method: "get",
    responseType: 'blob',
    url: `${apiUrl}/tasks-export?search=${search}${filters}${typefilter}&start_date=${start_date}&end_date=${end_date}&data_type=${data_type}&yearEnd_startDate=${yearEnd_startDate}&YearEnd_end_date=${YearEnd_end_date}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `workflow-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });
}

function download_turnaround_report(filter,filtertype,start_date,end_date,data_type=0,search='',yearEnd_startDate='',YearEnd_end_date='',report_type=''){
  let filters = '';
  if(filter){
    filters = `&filters=${JSON.stringify(filter)}`;
  }
  let typefilter = '';
  if(filtertype!=''){
    typefilter = `&filtertype=${filtertype}`;
  }
  let reportType = '';
  if(report_type!=''){
    reportType = `&report_type=${report_type}`;
  }
  return axios({
    method: "get",
    responseType: 'blob',
    url: `${apiUrl}/turnaround-tasks-export?search=${search}${filters}${typefilter}&start_date=${start_date}&end_date=${end_date}&data_type=${data_type}&yearEnd_startDate=${yearEnd_startDate}&YearEnd_end_date=${YearEnd_end_date}${reportType}`,
    headers: { Authorization: `Bearer ${authtoken}`, "Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const suffix = report_type ? `-${report_type}` : '';
    const outputFilename = `turnaround-report${suffix}-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
  }, error => {
    return error.response;
  })
  .catch(function (error) {
    console.log(error.response && error.response.status);
  });
}


function download_all_file(userid,taskid){
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/zipFileDownload?user_id=${userid}&task_id=${taskid}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `clientdata.zip`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });    
}
function download_all_fileS3(userid,taskid){
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/zipFileDownloadS3?user_id=${userid}&task_id=${taskid}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `clientdata.zip`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });    
}

function get_files_folders(task_id,user_id){
  return axios({
    method: "get",
    url: `${apiUrl}/get_files_folders?user_id=${user_id}&task_id=${task_id}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });    
}


function getclientstatus(){
  return axios({
    method: "get",
    url: `${apiUrl}/clientstatuslist`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function getclienttransitionstatus(){
  return axios({
    method: "get",
    url: `${apiUrl}/clienttransitionstatuslist`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function getrejectionstatus(){
  return axios({
    method: "get",
    url: `${apiUrl}/rejectionstatuslist`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}
function download_file(path,name,extension,task_id='',s3_bucket=0){
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/download_file?path=${encodeURIComponent(path)}&task_id=${task_id}&s3_bucket=${s3_bucket}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `${name}.${extension}`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
    // return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });    
}
function getgovernancestatus(){
  return axios({
    method: "get",
    url: `${apiUrl}/getgovernancestatus`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function getBillingDashboardStatistics(filter){
  
  return axios({
    method: "get",
    url: `${apiUrl}/getbillingdashboarddata?department=${filter.department}&fromdate=${filter.fromdate}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
      console.log('aaa',response)
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}


function getBillingDashboardData(filter,api,page){
  
  return axios({
    method: "get",
    url: `${apiUrl}/getbillingdashboardtabledata?department=${filter.department}&fromdate=${filter.fromdate}&page=${page}&perpage=${filter.perpage}&url=${api}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
      console.log('aaa',response)
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function client_task_report(filter,filtertype){
  let filters = '';
  let search = '';
  if(filter){
     filters = `&filters=${JSON.stringify(filter)}`;
  }
  let typefilter = '';
  if(filtertype!=''){
     typefilter = `&filtertype=${filtertype}`;
  }
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/client-tasks-export?search=${search}${filters}${typefilter}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `client-task-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}
function transitionForm(user_id,trans_id){
  return axios({
    method: "get",
    url: `${apiUrl}/transitionForm?user_id=${user_id}&trans_id=${trans_id}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function clientdetailsexportmail(user_id,start_date,end_date,flag,bodydata,name,data='',cc='',to,bcc='',popupData2=[]){
  console.log(data)
  const formData = new FormData();
  formData.append("user_id",user_id);
  formData.append("start_date",start_date);
  formData.append("end_date",end_date);
  formData.append("bodydata",bodydata);
  formData.append("flag",flag);
  formData.append("tomail",to);
  formData.append("ccmail",cc);
  formData.append("bccmail",bcc);
  formData.append("name",encodeURIComponent(name));
  if(popupData2 && popupData2.length > 0){
    formData.append("edited_data2", JSON.stringify(popupData2));
  }
  if(data.mail_attachemnt){
    data.mail_attachemnt.forEach((file, i) => {
      formData.append(`attachemnt[${i}]`,
      new Blob([file], { type: file.type }),
      file.name || ""
      );
    });

}
  console.log(data)
  return axios({
    method: "post",
    data: formData,
    url: `${apiUrl}/clientdetailsexportmail`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function save_budget(data){
  return axios({
    method: "post",
    data:data,
    url: `${apiUrl}/save_budget`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function get_budget_client(){
  return axios({
    method: "get",
    url: `${apiUrl}/get_budget_client`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function save_announcement(data){
  return axios({
    method: "post",
    data:data,
    url: `${apiUrl}/save_announcement`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function getAnnouncement(){
  return axios({
    method: "get",
    url: `${apiUrl}/getAnnouncement`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function getsingleAnnouncement(id){
  return axios({
    method: "get",
    url: `${apiUrl}/getsingleAnnouncement?id=${id}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function update_announcement(data){
  return axios({
    method: "post",
    url: `${apiUrl}/updateAnnouncement`,
    data: data,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function deleteAnnouncement(id){
  return axios({
    method: "get",
    url: `${apiUrl}/deleteAnnouncement?id=${id}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function getactiveAnnouncement(){
  return axios({
    method: "get",
    url: `${apiUrl}/getactiveAnnouncement`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function getclienttransByTask(id){
  return axios({
    method: "get",
    url: `${apiUrl}/getclienttransByTask?id=${id}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function phasedelete(id){
  return axios({
    method: "get",
    url: `${apiUrl}/phase-delete?id=${id}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function getchecklistData(task_id,type,id){
  return axios({
      method: "get",
      url: `${apiUrl}/getchecklistData?task_id=${task_id}&id=${id}&type=${type}`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      if(response.status == 200){
        return response;
       }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        console.log(error.response.status);
      });      
}
function editChecklistForm(value,field,form_id,task_id,phase_id,master_id){
  var bodyFormData = new FormData();
  bodyFormData.append("task_id", task_id);
  bodyFormData.append("phase_id", phase_id);
  bodyFormData.append("form_id", form_id);
  bodyFormData.append("field", field);
  bodyFormData.append("value", value);
  bodyFormData.append("master_id", master_id);
  return axios({
      method: "POST",
      url: `${apiUrl}/checklistform-edit`,
      data: bodyFormData,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
        return response;
      }, error => {
       // return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}

function editChecklistUpdate(value,field,id){
  var bodyFormData = new FormData();
      bodyFormData.append("id", id);
      bodyFormData.append("field", field);
      bodyFormData.append("value", value);
  return axios({
      method: "POST",
      url: `${apiUrl}/checklistform-update`,
      data: bodyFormData,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
        return response;
      }, error => {
       // return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}

function addChecklistData(requestdata,type,sub_cat){
  const formData = new FormData();
  formData.append("task_id", requestdata.task_id);
  formData.append("phase_id", requestdata.phase_id);
  formData.append("type", type);
  Object.keys(requestdata.data[sub_cat]).forEach((phase, index) => {
    formData.append(`data[${index}]`, JSON.stringify(requestdata.data[sub_cat][index]));
  });
  return axios({
    method: "post",
    url: `${apiUrl}/addChecklistData`,
    data: formData,
    headers: { Authorization: `Bearer ${authtoken}`,'Content-Type': 'multipart/form-data', },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    }); 
}
function updateDashboardChecklistData(requestdata,type,sub_cat){

  const formData = new FormData();
  formData.append("task_id", requestdata.task_id);
  formData.append("phase_id", requestdata.phase_id);
  formData.append("type", type);
  Object.keys(requestdata.data[sub_cat]).forEach((phase, index) => {
    formData.append(`data[${index}]`, JSON.stringify(requestdata.data[sub_cat][index]));
  });
  return axios({
    method: "post",
    url: `${apiUrl}/checklistDashboardformUpdate`,
    data: formData,
    headers: { Authorization: `Bearer ${authtoken}`,'Content-Type': 'multipart/form-data', },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    }); 
}
function get_single_manager_rejection(table,id){
  return axios({
    method: "get",
    url: `${apiUrl}/get_single_manager_rejection?table=${table}&id=${id}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
    if(response.status == 200){
      return response;
     }
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });      
}
function getKYCDashboard(page,search,filtertype,per_page){
  
  let typefilter = '';
  if(filtertype!=''){
     typefilter = `&filtertype=${filtertype}`;
  }
    return axios({
        method: "get",
        url: `${apiUrl}/getKYCDashboard?page=${page}&search=${search}${typefilter}&per_page=${per_page}`,
        headers: {Authorization: `Bearer ${authtoken}` },
      })
        .then(function (response) {
           if(response.status == 200){
                return response;  
           }
        }, error => {
          return error.response;
          console.log(error.response.status);
        })
        .catch(function (error) {
          // console.log(error.response.status);
        });      
}
function download_KYCDashreport(filtertype){
  let filters = '';
  let search = '';
  let typefilter = '';
  if(filtertype!=''){
     typefilter = `&filtertype=${filtertype}`;
  }
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/getKYCDashboard?search=${search}${typefilter}&export=1`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `KYC-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}
function download_clientList(client='',entity=''){

  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/download_clientList?client=${encodeURIComponent(client)}&entity=${entity}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `ClientList-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}
function getPhases(){
  return axios({
    method: "get",
    url: `${apiUrl}/getPhases`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
    if(response.status == 200){
      return response;
     }
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });      
}
function getPriceRevisionDashboard(page,search,filtertype,per_page,year){
  
  let typefilter = '';
  if(filtertype!=''){
     typefilter = `&filtertype=${filtertype}`;
  }
    return axios({
        method: "get",
        url: `${apiUrl}/getPriceRevisionDashboard?page=${page}&search=${search}${typefilter}&per_page=${per_page}&year=${year}`,
        headers: {Authorization: `Bearer ${authtoken}` },
      })
        .then(function (response) {
           if(response.status == 200){
                return response;  
           }
        }, error => {
          return error.response;
          console.log(error.response.status);
        })
        .catch(function (error) {
          // console.log(error.response.status);
        });      
}
function anniversarymailsend(id){
  return axios({
    method: "get",
    url: `${apiUrl}/anniversarymailsend?id=${id}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
    if(response.status == 200){
      return response;
     }
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });     
}
function editCommonTable(value,column,id,table_name){
  const formData = new FormData();
  formData.append("value", value);
  formData.append("column", column);
  formData.append("id", id);
  formData.append("table_name", table_name);
  return axios({
    method: "post",
    url: `${apiUrl}/editCommonTable`,
    data: formData,
    headers: { Authorization: `Bearer ${authtoken}`,'Content-Type': 'multipart/form-data', },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    }); 
}
function getchecklistSubCatData(phase_id){
 
    return axios({
        method: "get",
        url: `${apiUrl}/getchecklistSubCatData?phase_id=${phase_id}`,
        headers: {Authorization: `Bearer ${authtoken}` },
      })
      .then(function (response) {
        if(response.status == 200){
          return response;
         }
        }, error => {
          return error.response;
        })
        .catch(function (error) {
          console.log(error.response.status);
        });      
  
}
function getPhaseClientdetail(phase_id,type,start_date,end_date){
  return axios({
    method: "get",
    url: `${apiUrl}/getPhaseClientdetail?phase_id=${phase_id}&type=${type}&start_date=${start_date}&end_date=${end_date}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
    });
}
function anniversarydashboardCountData(){
 
  return axios({
      method: "get",
      url: `${apiUrl}/anniversarydashboardCountData`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      if(response.status == 200){
        return response;
       }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        console.log(error.response.status);
      });      

}
function download_anniversary_report(page,search,filtertype,per_page,year){
  let typefilter = '';
  if(filtertype!=''){
     typefilter = `&filtertype=${filtertype}`;
  }
 return axios({
   method: "get",
   responseType: 'blob', 
   url: `${apiUrl}/getPriceRevisionDashboard?search=${search}${typefilter}&download=1`,
   headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
 })
 .then(function (response) {
   const outputFilename = `anniversary-report-${Date.now()}.xlsx`;
   const url = URL.createObjectURL(new Blob([response.data]));
   const link = document.createElement('a');
   link.href = url;
   link.setAttribute('download', outputFilename);
   document.body.appendChild(link);
   link.click();
// return response;
   }, error => {
     return error.response;
   })
   .catch(function (error) {
     console.log(error.response.status);
   });  
}
function getMisMailDetails(page,per_page,id){
 
  return axios({
      method: "get",
      url: `${apiUrl}/getMisMailDetails?page=${page}&per_page=${per_page}&id=${id}`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      if(response.status == 200){
        return response;
       }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        console.log(error.response.status);
      });      

}
function getMisMailWeeklyData(page,per_page,filter){
 let filters = '';
  let search = '';
  if(filter){
     filters = `&filters=${JSON.stringify(filter)}`;
  }
  return axios({
      method: "get",
      url: `${apiUrl}/getMisMailWeeklyData?page=${page}&per_page=${per_page}&search=${filters}`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      if(response.status == 200){
        return response;
       }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        console.log(error.response.status);
      });      

}
function getpodData(page,data){
 
  return axios({
      method: "get",
      url: `${apiUrl}/podScreen?page=${page}&process_order=${data.process_order}`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      if(response.status == 200){
        return response;
       }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        console.log(error.response.status);
      });      

}

function kanbanviewdata(page,data){
  return axios({
      method: "get",
      url: `${apiUrl}/kanbanBoard?page=${page}&process_order=${data.process_order}`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      if(response.status == 200){
        return response;
       }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        console.log(error.response.status);
      });      
}

function ageingreport(data){
  return axios({
      method: "get",
      url: `${apiUrl}/ageingreport?user_id=${data.user_id}&tl_id=${data.tl_id}&status=${data.status}&type=${data.type}&date_type=${data.date_type}&tab_type=${data.tab_type}`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      if(response.status == 200){
        return response;
       }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        console.log(error.response.status);
      });      

}
function ageingdetails(status,ageing,data){
 
  return axios({
      method: "get",
      url: `${apiUrl}/ageingdetail?user_id=${data.user_id}&tl_id=${data.tl_id}&status=${status}&ageing=${ageing}&type=${data.type}&date_type=${data.date_type}&tab_type=${data.tab_type}`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      if(response.status == 200){
        return response;
       }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        console.log(error.response.status);
      });      

}

function deleteBillingBreakup(id){
  return axios({
    method: "get",
    url: `${apiUrl}/deleteBillingBreakup?id=${id}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function removeChecklistRow(data,type){
console.log(data)
let idParam;

  if (Array.isArray(data.ids)) {
    idParam = data.ids.join(',');
  } else {
    idParam = data; // Use data directly if numeric
  }
  return axios({
    method: "get",
    url: `${apiUrl}/removeChecklistRow?id=${idParam}&type=${type}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function getReworkData(id,task_id){
  return axios({
    method: "get",
    url: `${apiUrl}/getReworkData?id=${id}&task_id=${task_id}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
    });
}
function editReworkField(id,field,value){
  var bodyFormData = new FormData();
  bodyFormData.append("id", id);
  bodyFormData.append("field", field);
  bodyFormData.append("value", value);
  return axios({
    method: "post",
    data:bodyFormData,
    url: `${apiUrl}/editReworkField`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
    });
}

function getOnHoldHistory(task_id){
  return axios({
    method: "get",
    url: `${apiUrl}/getOnHoldHistory?task_id=${task_id}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;
       }
    }, error => {
      return error.response;
    })
    .catch(function (error) {
    });
}

function getJobHistory(task_id){
  return axios({
    method: "get",
    url: `${apiUrl}/getJobHistory?task_id=${task_id}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;
       }
    }, error => {
      return error.response;
    })
    .catch(function (error) {
    });
}

function getReassignData(id,task_id){
  return axios({
    method: "get",
    url: `${apiUrl}/getReassignData?id=${id}&task_id=${task_id}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;
       }
    }, error => {
      return error.response;
    })
    .catch(function (error) {
    });
}

function editReassignField(id,field,value){
  var bodyFormData = new FormData();
  bodyFormData.append("id", id);
  bodyFormData.append("field", field);
  bodyFormData.append("value", value);
  return axios({
    method: "post",
    data:bodyFormData,
    url: `${apiUrl}/editReassignField`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;
       }
    }, error => {
      return error.response;
    })
    .catch(function (error) {
    });
}
function archiveChecklistFeedback(data){
  return axios({
    method: "post",
    url: `${apiUrl}/archiveChecklistFeedback`,
    data: data,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}
function getChecklistFeedbackData(){
  return axios({
    method: "get",
    url: `${apiUrl}/getChecklistFeedbackData`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function getQAChecklistFeedbackData(task_id){
  return axios({
    method: "get",
    url: `${apiUrl}/getQAChecklistFeedbackData?task_id=${task_id}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function deleteRej(id){
  return axios({
    method: "get",
    url: `${apiUrl}/deleteRej?id=${id}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;  
    }, error => {
      return error.response;
    //   console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function add_timesheet(data) {
  var bodyFormData = new FormData();
  bodyFormData.append("task_id", data.task_id);
  bodyFormData.append("date", data.date);
  bodyFormData.append("minutes", data.minutes);
  bodyFormData.append("remarks", data.description);
  bodyFormData.append("usedhours", data.usedhours);
  bodyFormData.append("budget_hours", data.budget_hours);
  bodyFormData.append("budget_minutes", data.budget_minutes);
  bodyFormData.append("remaining_minutes", data.remaining_minutes);
  bodyFormData.append("tasktype", data.tasktype);

  return axios({
      method: "POST",
      url: `${apiUrl}/add-timesheet`,
      data: bodyFormData,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
        return response;
      }, error => {
       // return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}
function get_timesheet_data(task_id, date) {
  return axios({
    method: "get",
    url: `${apiUrl}/get-timesheet?task_id=${task_id}&date=${date}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
      if(response.status == 200){
        return response;
       }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        console.log(error.response.status);
      });      
}

function getTasksList(){
  return axios({
    method: "get",
    url: `${apiUrl}/getTimesheetTasksList`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function getdocumentdetail(task_id){
  return axios({
    method: "get",
    url: `${apiUrl}/getFilesDoc?task_id=${task_id}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });    
}

function s3Browse(task_id, prefix = ""){
  return axios({
    method: "get",
    url: `${apiUrl}/s3-browse?task_id=${task_id}&prefix=${encodeURIComponent(prefix)}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });
}

function s3BucketBrowse(prefix = ""){
  return axios({
    method: "get",
    url: `${apiUrl}/s3-bucket-browse?prefix=${encodeURIComponent(prefix)}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });
}

function getDocumentsView(id){
  return axios({
    method: "get",
    url: `${apiUrl}/showdocuments/${id}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });
}

function reprocessDocument(payload) {
  
  return axios({
    method: "POST",
    url: `${apiUrl}/documents/reprocess`,
    data: payload,
    headers: {
      Authorization: `Bearer ${authtoken}`,
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.response) {
        console.error(
          "Reprocess error:",
          error.response.status,
          error.response.data
        );
      } else {
        console.error("Reprocess error:", error.message);
      }
      throw error;
    });
}
function addInternalPhaseError(data){
  return axios({
    method: "POST",
    url: `${apiUrl}/internal-phase-error`,
    data: data,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
         return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function getOnHoldPhases(){
  return axios({
      method: "get",
      url: `${apiUrl}/on-hold-phases`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
         if(response.status == 200){
              return response;
         }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
      });
}

// Checklist Feedback rejection-tracking fields (BRD 6499)
function updateFeedbackTracking(value,field,id){
  var bodyFormData = new FormData();
      bodyFormData.append("id", id);
      bodyFormData.append("field", field);
      bodyFormData.append("value", value == null ? '' : value);
  return axios({
      method: "POST",
      url: `${apiUrl}/checklistFeedbackTracking`,
      data: bodyFormData,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
        return response;
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });
}

function getFeedbackOptions(all=0){
  return axios({
    method: "get",
    url: `${apiUrl}/feedback-options?all=${all}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function saveFeedbackOption(option){
  var bodyFormData = new FormData();
  Object.keys(option).forEach((key) => {
    if(option[key] !== undefined && option[key] !== null){
      bodyFormData.append(key, option[key]);
    }
  });
  return axios({
      method: "post",
      url: `${apiUrl}/feedback-options`,
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
         return response;
      }, error => {
          return error.response;
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });
}
